import { render } from "./selectedtopics.vue?vue&type=template&id=40db8522&scoped=true&ts=true"
import script from "./selectedtopics.vue?vue&type=script&lang=ts"
export * from "./selectedtopics.vue?vue&type=script&lang=ts"

import "./selectedtopics.vue?vue&type=style&index=0&id=40db8522&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40db8522"]])

export default __exports__